<template>
  <template v-if="visibleIndicatorList.length != 0">
    <div>
      <SectionTitle text="Ключевые показатели" class="mb-20" />
      <div class="analytics-tab">
        <EconomicsReviewCard title="Реальный сектор" :indicators="visibleIndicatorList">
          <template #item="{ item }">
            <template v-if="item.value">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center mr-24">
                  <div class="analytics-source-text fs12 mr-10" v-if="item.place">
                    <template v-if="item.value != '0,00'">
                      <p
                        :class="[{ 'placeTypeBlock-yellow': item.id == 1 }, { 'placeTypeBlock-green': item.id != 1 }]"
                        class="d-flex"
                      >
                        {{ item.place }} <IconComponent class="ml-4 white" name="threeStripes" />
                      </p>
                    </template>
                  </div>
                  <strong class="indicators__value">{{ item.value == '0' ? '-' : item.value }}</strong>
                </div>
                <div class="awards fs12" v-if="item.awards">
                  <p class="awards__first">
                    1 <IconComponent class="ml-10 mr-16 gray" name="threeStripes" /> {{ item.awards.firstPlace }}
                    <span v-if="item.awards.firstValue">
                      ({{ formatNumber(item.awards.firstValue, item.id === 10 ? 2 : 1, '', ',') }})
                    </span>
                  </p>
                  <p class="awards__russia">
                    {{ getNumberPlace(item.awards.russiaPlace) }}
                    <IconComponent class="ml-4 mr-16 gray" name="threeStripes" /> Россия
                    <span v-if="item.awards.russiaValue">
                      ({{ formatNumber(item.awards.russiaValue, item.id === 10 ? 2 : 1, '', ',') }})
                    </span>
                  </p>
                </div>
              </div>
              <div v-if="item.period" class="analytics-source-text fs10">Период: {{ item.period }}</div>
            </template>
          </template>
        </EconomicsReviewCard>

        <EconomicsReviewCard title="Финансовый сектор" :indicators="indicatorsListFinancial">
          <template #item="{ item }">
            <template v-if="!item.isEmpty">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center mr-24">
                  <div class="analytics-source-text fs12 mr-10" v-if="item.place">
                    <p class="d-flex placeTypeBlock-blue">
                      {{ item.place }} <IconComponent class="ml-4 white" name="threeStripes" />
                    </p>
                  </div>
                  <strong class="indicators__value">{{ item.value }}</strong>
                </div>
                <div class="awards fs12" v-if="item.awards">
                  <p class="awards__first">
                    1 <IconComponent class="ml-10 mr-16 gray" name="threeStripes" /> {{ item.awards.firstPlace }}
                    <span v-if="item.awards.firstValue">({{ formatNumber(item.awards.firstValue, 1, '', ',') }})</span>
                  </p>
                  <p class="awards__russia">
                    {{ getNumberPlace(item.awards.russiaPlace) }}
                    <IconComponent class="ml-4 mr-16 gray" name="threeStripes" /> Россия
                    <span v-if="item.awards.russiaValue"
                      >({{ formatNumber(item.awards.russiaValue, 1, '', ',') }})</span
                    >
                  </p>
                </div>
              </div>
              <div v-if="item.period" class="analytics-source-text fs10">Период: {{ item.period }}</div>
              <div v-if="item.dateUpdate" class="analytics-source-text">Дата обновления: {{ item.dateUpdate }}</div>
            </template>
            <p v-else class="mt-20">{{ emptyMessage }}</p>
          </template></EconomicsReviewCard
        >

        <EconomicsReviewCard title="Позиция в мировых рейтингах" :indicators="countryRatingIndicators">
          <template #item="{ item }">
            <div class="d-flex align-items-center mb-6">
              <div class="d-flex align-items-center mr-24">
                <strong class="fs22 fw700">{{ item.numberPlace || '–' }}</strong>
              </div>
              <div class="awards fs12">
                <p class="awards__first">
                  1 <IconComponent class="ml-10 mr-16 gray" name="threeStripes" /> {{ item.awards.winner }}
                </p>
                <p class="d-flex">
                  {{ getNumberPlace(item.awards.russiaPlace) }}
                  <IconComponent class="ml-4 mr-16 gray" name="threeStripes" /> Россия
                </p>
              </div>
            </div>
            <div class="analytics-source-text fs10">Период: {{ item.period }} год</div>
          </template>
        </EconomicsReviewCard>
      </div>
    </div>
  </template>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import Constants from '@/common/constants';
  import text from '@/common/mixins/text';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import ApiFromCountryMap from '@/modules/countryАnalytics/api.js';

  import { COUNTRY_ANALYTICS_ACTIONS_NAME, COUNTRY_ANALYTICS_GETTERS_NAME } from '../../store/analytics/directoryNames';
  import { DATA_EMPTY_MESSAGE } from '../../utils/constants';
  import getPeriodDescription from '../../utils/period';
  import EconomicsReviewCard from './EconomicsReviewCard.vue';

  export default {
    name: 'EconomicsReview',
    mixins: [text],
    components: {
      IconComponent,
      EconomicsReviewCard,
      SectionTitle,
    },
    props: {
      countryId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        year: new Date().getFullYear(),
        indicatorsList: [],
        indicatorsListFinancial: [],
        countryRatingIndicators: [],
        indicatorsFromMap: null,
        emptyMessage: DATA_EMPTY_MESSAGE,
      };
    },
    watch: {
      countryId: function () {
        this.loadData();
      },
    },
    computed: {
      ...mapGetters({
        getBudgetDeficitIndicator: COUNTRY_ANALYTICS_GETTERS_NAME.getBudgetDeficitIndicator,
        getStockMarketCapitalizationIndicator: COUNTRY_ANALYTICS_GETTERS_NAME.getStockMarketCapitalizationIndicator,
        getFinancialAccountIndicator: COUNTRY_ANALYTICS_GETTERS_NAME.getFinancialAccountIndicator,
        getGovernmentBondYieldsIndicator: COUNTRY_ANALYTICS_GETTERS_NAME.getGovernmentBondYieldsIndicator,
        getSummaryEconomicReview: COUNTRY_ANALYTICS_GETTERS_NAME.getSummaryEconomicReview,
        getCountryRatingIndicators: COUNTRY_ANALYTICS_GETTERS_NAME.getCountryRatingIndicators,
      }),
      visibleIndicatorList() {
        return this.indicatorsList.filter((x) => (x.value || x.place) && x.value != '0,00');
      },
    },
    created() {
      this.loadData();
    },
    methods: {
      ...mapActions({
        getIndicatorBudgetDeficit: COUNTRY_ANALYTICS_ACTIONS_NAME.getIndicatorBudgetDeficit,
        getIndicatorStockMarketCapitalization: COUNTRY_ANALYTICS_ACTIONS_NAME.getIndicatorStockMarketCapitalization,
        getIndicatorFinancialAccount: COUNTRY_ANALYTICS_ACTIONS_NAME.getIndicatorFinancialAccount,
        getIndicatorGovernmentBondYields: COUNTRY_ANALYTICS_ACTIONS_NAME.getIndicatorGovernmentBondYields,
        getEconomicReviewSummary: COUNTRY_ANALYTICS_ACTIONS_NAME.getEconomicReviewSummary,
        getIndicatorCountryRating: COUNTRY_ANALYTICS_ACTIONS_NAME.getIndicatorCountryRating,
      }),
      async loadData() {
        this.indicatorsList = [];
        this.indicatorsListFinancial = [];
        await this.getEconomicReviewSummary({ year: this.year, countryId: this.countryId });

        this.buildIndicators(this.getSummaryEconomicReview);

        await this.getIndicatorBudgetDeficit({ countryId: this.countryId });

        await this.getIndicatorStockMarketCapitalization({ countryId: this.countryId });

        await this.getIndicatorFinancialAccount({ countryId: this.countryId });

        await this.getIndicatorGovernmentBondYields({ countryId: this.countryId });

        this.buildFinancialIndicators({
          summary: this.getSummaryEconomicReview,
          budget: this.getBudgetDeficitIndicator,
          stock: this.getStockMarketCapitalizationIndicator,
          finAccount: this.getFinancialAccountIndicator,
          govYield: this.getGovernmentBondYieldsIndicator,
        });

        await this.getIndicatorCountryRating({ countryId: this.countryId });

        this.buildCountryRatingIndicators(this.getCountryRatingIndicators);

        if (this.countryId != Constants.countryRussiaId) {
          ApiFromCountryMap.getExportProductLast(this.countryId).then((response) => {
            this.indicatorsFromMap = response.data;
          });
        }
      },
      resolveOrFallback(condition, getValue, fallback) {
        return condition ? getValue() : fallback;
      },
      buildIndicators(summary) {
        this.indicatorsList = [
          {
            id: 1,
            title: 'Население страны,\n' + 'млн чел.',
            period: this.resolveOrFallback(
              summary,
              () => `${summary.populationYear} год ${getPeriodDescription(summary.populationYear)}`,
              '',
            ),
            value: this.resolveOrFallback(
              summary,
              () => this.formatNumber(summary.population / Constants.MILLION, 1),
              '0,0',
            ),
            place: this.resolveOrFallback(summary, () => summary.populationPlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.populationAward, null),
          },
          {
            id: 2,
            title: 'ВВП в текущих ценах,\n' + 'млрд $ США',
            period: this.resolveOrFallback(
              summary,
              () => `${summary.gdpYear} год ${getPeriodDescription(summary.gdpYear)}`,
              '',
            ),
            value: this.resolveOrFallback(
              summary,
              () => this.formatNumber(summary.gdp / (Constants.MILLION * Constants.THOUSAND), 1),
              '0,0',
            ),
            place: this.resolveOrFallback(summary, () => summary.gdpPlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.gdpAward, null),
          },
          {
            id: 3,
            title: 'ВВП на душу населения (в текущих ценах),\n' + 'тыс. $ США',
            period: this.resolveOrFallback(
              summary,
              () => `${summary.gdpPerCapitaYear} год ${getPeriodDescription(summary.gdpPerCapitaYear)}`,
              '',
            ),
            value: this.resolveOrFallback(
              summary,
              () => this.formatNumber(summary.gdpPerCapita / Constants.THOUSAND, 1),
              '0,0',
            ),
            place: this.resolveOrFallback(summary, () => summary.gdpPerCapitaPlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.gdpPerCapitaAward, null),
          },
          {
            id: 4,
            title: 'Темп прироста ВВП (в постоянных ценах),\n' + 'в % к предыдущему году',
            period: this.resolveOrFallback(
              summary,
              () => `${summary.gdpGrowYear} год ${getPeriodDescription(summary.gdpGrowYear)}`,
              '',
            ),
            place: this.resolveOrFallback(summary, () => summary.gdpGrowPlace, 'Загрузка...'),
            chartData: summary?.gdpGrowValues,
            value: this.resolveOrFallback(
              summary?.gdpGrowValues,
              () => this.formatNumber(summary.gdpGrowValues[summary.gdpGrowValues.length - 1]?.currentValue, 1),
              '0,0',
            ),
            awards: this.resolveOrFallback(summary, () => summary.gdpGrowAward, null),
          },
          {
            id: 8,
            title: 'Уровень безработицы, %',
            period: this.resolveOrFallback(summary, () => summary.unemploymentRateYear + ' год', ''),
            value: this.resolveOrFallback(summary, () => this.formatNumber(summary.unemploymentRate, 1), '0,0'),
            place: this.resolveOrFallback(summary, () => summary.unemploymentRatePlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.unemploymentRateAward, null),
          },
          {
            id: 9,
            title: 'Инфляция (ИПЦ), %',
            period: this.resolveOrFallback(
              summary,
              () => this.$momentFormat(summary.inflationPeriod, Constants.DATE_FORMATS.MMMM_YYYY),
              '',
            ),
            value: this.resolveOrFallback(summary, () => this.formatNumber(summary.inflation, 1), '0,0'),
            place: this.resolveOrFallback(summary, () => summary.inflationPlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.inflationAward, null),
          },
          {
            id: 10,
            title: 'Учетная ставка ЦБ',
            period: this.resolveOrFallback(
              summary,
              () => this.$momentFormat(summary.bankRatePeriod, Constants.DATE_FORMATS.MMMM_YYYY),
              '',
            ),
            value: this.resolveOrFallback(summary, () => this.formatNumber(summary.bankRate, 2), '0,00'),
            place: this.resolveOrFallback(summary, () => summary.bankRatePlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.bankRateAward, null),
          },
          {
            id: 11,
            title: 'Счет текущих операций, % ВВП',
            period: this.resolveOrFallback(
              summary,
              () =>
                `${summary.currentAccountBalanceYear} год ${getPeriodDescription(summary.currentAccountBalanceYear)}`,
              '',
            ),
            value: this.resolveOrFallback(summary, () => this.formatNumber(summary.currentAccountBalance, 1), '0,0'),
            place: this.resolveOrFallback(summary, () => summary.currentAccountBalancePlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.currentAccountBalanceAward, null),
          },
        ];
      },
      isIndicatorEmpty(data) {
        return data === this.emptyMessage || data?.currentCountryPlace === Constants.MIN_INT_32;
      },
      buildRankedIndicator({ id, title, data, withPeriodDescription }) {
        return {
          id,
          title,
          period: this.resolveOrFallback(
            data?.year != null,
            () => `${data.year} год ${withPeriodDescription ? getPeriodDescription(data.year) : ''}`.trimEnd(),
            data?.year,
          ),
          place: data?.currentCountryPlace,
          value: this.resolveOrFallback(
            data?.currentCountryValue,
            () => this.formatNumber(data.currentCountryValue, 1),
            '0,0',
          ),
          awards: {
            firstPlace: data?.firstCountry,
            russiaPlace: this.getAwardsRussianPlace(data),
            russiaValue: this.getAwardsRussianValue(data),
            firstValue: data?.firstValue,
          },
          isEmpty: this.isIndicatorEmpty(data),
        };
      },
      buildFinancialIndicators({ summary, budget, stock, finAccount, govYield }) {
        this.indicatorsListFinancial = [
          {
            id: 5,
            title: 'Суверенные рейтинги\n' + '(S&P, Moody`s, Fitch)',
            dateUpdate: this.resolveOrFallback(
              summary,
              () => this.$momentFormat(summary.sovereignRatingUpdateDate, Constants.DATE_FORMATS['DD.MM.YYYY']),
              '09.12.2022',
            ),
            value: this.resolveOrFallback(summary, () => summary.sovereignRating, '-'),
          },
          {
            id: 6,
            title: 'Государственный долг,\n' + '% ВВП',
            period: this.resolveOrFallback(
              summary,
              () => `${summary.governmentDebtYear} год ${getPeriodDescription(summary.governmentDebtYear)}`,
              null,
            ),
            value: this.resolveOrFallback(
              summary?.governmentDebt,
              () => this.formatNumber(summary.governmentDebt, 1),
              '0,0',
            ),
            place: this.resolveOrFallback(summary, () => summary.governmentDebtPlace, 'Загрузка...'),
            awards: this.resolveOrFallback(summary, () => summary.governmentDebtAward, null),
          },
          {
            id: 7,
            title: 'Золотовалютные резервы,\n' + 'млрд $ США',
            period: this.resolveOrFallback(summary, () => `${summary.reservesYear} год`, null),
            value: this.resolveOrFallback(
              summary?.reserves,
              () => this.formatNumber(summary.reserves / (Constants.MILLION * Constants.THOUSAND), 1),
              '0,0',
            ),
            place: this.resolveOrFallback(summary, () => summary.reservesPlace, 'Загрузка...'),
            awards: this.resolveOrFallback(
              summary,
              () => ({
                ...summary.reservesAward,
                firstValue: summary.reservesAward?.firstValue / (Constants.MILLION * Constants.THOUSAND),
              }),
              null,
            ),
          },
          this.buildRankedIndicator({
            id: 8,
            title: 'Дефицит бюджета,\n' + ' % ВВП',
            data: budget,
            withPeriodDescription: true,
          }),
          this.buildRankedIndicator({
            id: 9,
            title: 'Капитализация рынка акций,\n' + ' млрд $ США',
            data: stock,
            withPeriodDescription: false,
          }),
          this.buildRankedIndicator({
            id: 10,
            title: 'Финансовый счет,\n' + ' % ВВП',
            data: finAccount,
            withPeriodDescription: true,
          }),
          this.buildRankedIndicator({
            id: 11,
            title: 'Доходность государственных облигаций,\n' + ' % годовых',
            data: govYield,
            withPeriodDescription: false,
          }),
        ];
      },
      buildCountryRatingIndicators(rating) {
        this.countryRatingIndicators = [
          {
            id: 12,
            title: 'Индекс развития электронного Правительства',
            numberPlace: rating.egdiPlace,
            awards: {
              russiaPlace: rating.russiaEgdiPlace,
              winner: rating.egdiWinner,
            },
            period: rating.ratingUpdateYear,
          },
          {
            id: 13,
            title: 'Индекс человеческого развития',
            numberPlace: rating.hdiRank,
            awards: {
              russiaPlace: rating.russiaHdiRankPlace,
              winner: rating.hdiRankWinner,
            },
            period: rating.ratingUpdateYear,
          },
          {
            id: 14,
            title: 'Индекс глобальных финансовых рынков',
            numberPlace: rating.gfcPlace,
            awards: {
              russiaPlace: rating.russiaGfcPlace,
              winner: rating.gfcWinner,
            },
            period: rating.ratingUpdateYear,
          },
        ];
      },
      getAwardsRussianPlace(item) {
        // при отсутствии данных с бэка приходит минимальное значение int32 вместо Null, поэтому такое сравнение
        return item?.russianPlace === Constants.MIN_INT_32 ? '-' : item?.russianPlace;
      },
      getAwardsRussianValue(item) {
        return item?.russianValue === Constants.MIN_INT_32 ? null : item?.russianValue;
      },
      getNumberPlace(value) {
        return Number(value) || '-';
      },
    },
  };
</script>

<style scoped lang="scss">
  .analytics-tab {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .indicators {
    &__value {
      min-width: 70px;
      font-size: 22px;
      font-weight: 700;
    }
  }

  .awards {
    &__russia,
    &__first {
      span {
        margin-left: 5px;
      }
    }

    &__russia {
      display: flex;
      flex-wrap: wrap;
    }
    &__first {
      display: flex;
      margin-bottom: 8px;
      align-items: center;
    }
  }
</style>
